import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { ITranslationFactors } from 'legacy/lut/classes/models/partner360/ITranslationFactors'
import { Dispatch, SetStateAction } from 'react'

import { IJBPPlanningItem } from '../../models/IJBPPlanning'
import { OVERALL_CATEGORY, PLANNING_BY_FY_FQ } from '../config'
import { IFieldProps } from '../models/IFieldProps'

import { setItemValuesUniversal } from './setItemValuesUniversal'

interface IProps {
  items: IJBPPlanningItem[]
  setting: IFormActualsTargetsSettings
  fieldProps: IFieldProps
  fy: number
  setTargetsItems: Dispatch<SetStateAction<IJBPPlanningItem[]>>
  translationFactors?: ITranslationFactors[] | null
}

export const cleanQuartersAndFY = ({
  items,
  setting,
  fieldProps,
  fy,
  setTargetsItems,
  translationFactors,
}: IProps) => {
  const data = [...items]

  // Filtered on Top level: PartnerId, ProgramTypes, Category, IsActuals, IsTarget, IsQuota

  // Set Quarters and PLANNING_BY_FY_FQ
  for (let fq = 1; fq <= PLANNING_BY_FY_FQ; fq++) {
    const qData = items.filter(
      (el) =>
        el.ProgramTypes === setting.ProgramType &&
        el.Category === setting.Category &&
        !!el.SubCategory &&
        el.SubCategory !== OVERALL_CATEGORY &&
        el.FYear === fy &&
        el.FQuarter === fq
    )
    qData.forEach((el) => {
      const newItem = setItemValuesUniversal(
        el,
        0,
        fieldProps,
        setting.Category,
        false,
        translationFactors
      )

      const idx = items.indexOf(el)
      data.splice(idx, 1, newItem)
    })
  }

  setTargetsItems([...data])

  return data
}
